import { render, staticRenderFns } from "./MainDrawer.vue?vue&type=template&id=30fa83f6"
import script from "./MainDrawer.vue?vue&type=script&lang=js"
export * from "./MainDrawer.vue?vue&type=script&lang=js"
import style0 from "./MainDrawer.vue?vue&type=style&index=0&id=30fa83f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports